<div class="flex flex-row-reverse justify-around items-center min-h-[100vh] bg-[#FDF0D5]">
  <div id="banner"
    class="w-[660px] h-[90vh] flex rounded-[30px] bg-[var(--lightGrayPurple)] my-[20px] flex flex-col relative">
    <div class="w-[55%] fosco flex flex-col ml-5 mt-8" id="container1">
      <h5 class="text-white">
        Seu futuro<br>começa aqui
      </h5>
      <span class="text-white">
        Alunos que resolvem questões tiram notas 72% mais altas.
      </span>
    </div>
  </div>
  <div id="login_container"
    class="w-[500px] h-[500px] flex items-center justify-center rounded-md flex flex-col gap-10 bg-[#FDF0D5]">
    <img src="/assets/logo_blue_dark.svg" alt="Logo" class="w-[250px]" />
    <form [formGroup]="loginForm" (ngSubmit)="login()" class="flex flex-col gap-4 w-full px-[50px]">
      <input formControlName="email" type="text" name="email" placeholder="E-mail" class="p-2 rounded-md" />
      <input formControlName="password" type="password" name="password" placeholder="Senha" class="p-2 rounded-md" />
      <button type="submit" class="p-2 text-white bg-[#669BBC] rounded-md cursor-pointer"
        [disabled]="isLoading || loginForm.invalid">
        <span *ngIf="!isLoading">
          Entrar
        </span>
        <span *ngIf="isLoading">
          Carregando...
        </span>
      </button>
    </form>
    <div class="flex flex-col text-center flex gap-3 ">
      <a [routerLink]="['/login']" class="text-[var(--darkPurple)] hidden">Esqueci a senha</a>
      <span class="text-[#4D748D]">Não possui uma conta?
        <a class="text-[#263b47]" [routerLink]="['/signup']">Cadastre-se</a></span>
    </div>
  </div>
</div>